<template>
  <TooltipProvider class="h-full">
    <router-view />
  </TooltipProvider>
  <Toaster
    position="bottom-right"
    :toast-options="{ style: toastStyle }"
    :icons="toastIcons"
    :offset="24"
  />
</template>
<script lang="ts" setup>
import { CircleCheck } from '@owner/icons-vue/CircleCheck'
import { CircleInfo } from '@owner/icons-vue/CircleInfo'
import { CircleX } from '@owner/icons-vue/CircleX'
import { TriangleExclamation } from '@owner/icons-vue/TriangleExclamation'
import { useFavicon } from '@vueuse/core'
import { storeToRefs } from 'pinia'
import { TooltipProvider } from 'reka-ui'
import { h, onMounted, watchEffect } from 'vue'

import { Toaster } from 'vue-sonner'

import 'vue-sonner/style.css'

import { useAuthStore } from '@/auth/useAuthStore'
import { useHestiaPreload } from '@/features/hestia/composables/useHestiaPreload'
import { cobrowse } from '@/plugins/cobrowse'
import { FeatureFlags } from '@/plugins/featureFlags'
import { useReactiveFeatureFlag } from '@/utils/useFeatureFlags'

import { useLocaleHandler } from './composables/useLocaleHandler'
import { usePageTitle } from './composables/usePageTitle'
import { useSessionManager } from './composables/useSessionManager'

const toastStyle = {
  borderRadius: 'var(--radius-regular)',
  fontFamily: 'var(--font-family)',
  fontSize: '13px',
}

const iconProps = { size: 18 }
const toastIcons = {
  error: () => h(CircleX, iconProps),
  info: () => h(CircleInfo, iconProps),
  success: () => h(CircleCheck, iconProps),
  warning: () => h(TriangleExclamation, iconProps),
}

useHestiaPreload()
useLocaleHandler()
usePageTitle()
useSessionManager()
useFavicon(
  import.meta.env.MODE !== 'production'
    ? '/favicon/favicon-dev.ico'
    : '/favicon/favicon.ico'
)

const { user } = storeToRefs(useAuthStore())

const updateFeatureFlagCtx = () => {
  if (user.value) {
    if (user.value.email) {
      FeatureFlags.setContextField('userId', user.value.email)
    } else {
      FeatureFlags.setContextField('userId', user.value.id)
    }
  }
}

const enhancedDesign = useReactiveFeatureFlag('hermes.enhancedDesignDensity')

watchEffect(() => {
  document.documentElement.classList.toggle(
    'enhanced-design',
    enhancedDesign.enabled.value
  )
})

onMounted(() => {
  updateFeatureFlagCtx()
  void cobrowse.load()
})
</script>
